(function() {
  'use strict';

  /**
   * Contrôleur pour la page du glossaire
   */
  angular
    .module('observatoireApp')
    .controller('GlossaireController', ['$scope', '$http', '$timeout', 'GlossaireService', GlossaireController]);

  function GlossaireController($scope, $http, $timeout, GlossaireService) {
    // Variables du scope
    $scope.termes = [];
    $scope.termesFiltres = [];
    $scope.loading = true;
    $scope.filtreTerme = '';
    $scope.lettreActive = 'all';
    $scope.alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

    // Initialisation
    init();

    /**
     * Initialisation du contrôleur
     */
    function init() {
      // Chargement des données du glossaire
      chargerGlossaire();

      // Surveiller les changements dans le filtre de recherche
      $scope.$watch('filtreTerme', function(newVal) {
        filtrerTermes();
      });
    }

    /**
     * Charge les données du glossaire (données statiques)
     */
    function chargerGlossaire() {
      $scope.loading = true;
      $scope.errorMessage = null;
      
      // Utilisation des données statiques fournies
      $timeout(function() {
        $scope.termes = [
          {
            terme: "Adoption du budget",
            definition: "Processus formel par lequel est adopté le budget à l'Assemblée Nationale."
          },
          {
            terme: "Aide ou appui budgétaire",
            definition: "Procédé par lequel l'aide au développement est directement intégrée dans le budget de l'État et affectée à certaines priorités, sans passer par l'intermédiaire d'un projet."
          },
          {
            terme: "Arbitrage",
            definition: "Phase de concertation entre le gouvernement et les ministères, permettant de définir des enveloppes indicatives par ministère. Les montants indicatifs de ces enveloppes peuvent être plus ou moins fermes et peuvent être répartis entre différents programmes, voire même entre actions."
          },
          {
            terme: "Bons de Trésor",
            definition: "Emprunts à court terme émis par l'État pour financer ses besoins de trésorerie."
          },
          {
            terme: "Budget annexe",
            definition: "Budget retraçant les dépenses et les recettes d'un service de l'État dont l'activité tend essentiellement à produire des biens ou à rendre des services donnant lieu à un paiement. Ils constituent des missions et sont spécialisés par programme."
          },
          {
            terme: "Budget axé sur les résultats",
            definition: "Budget qui lie les dépenses à l'atteinte de certains résultats plutôt qu'à l'achat d'intrants. Le budget de l'Etat est élaboré, présenté et exécuté sous forme de programmes traduisant les politiques publiques auxquelles sont associées des objectifs assortis d'indicateurs de résultats."
          },
          {
            terme: "Budget citoyen",
            definition: "Document simplifié de la Loi de Finances, résumant et expliquant au citoyen la façon dont les dépenses sont réparties pour financer les services publics, ainsi que les recettes provenant de diverses sources."
          },
          {
            terme: "Budget général de l'Etat",
            definition: "Document qui retrace toutes les recettes budgétaires et toutes les dépenses de l'État, à l'exception des recettes affectées par la loi aux budgets annexes et aux comptes spéciaux."
          },
          {
            terme: "Cadre budgétaire à moyen terme (CBMT)",
            definition: "Instrument de programmation pluriannuel glissant pour l'ensemble des recettes et des dépenses."
          },
          {
            terme: "Cardre de dépenses à moyen terme (CDMT)",
            definition: "Instrument budgétaire sectoriel pluriannuel glissant établi en référence au CBMT, les CDMT présentent l'évolution budgétaire des programmes sur une période de trois ans. Tous les ministères, budgets annexes et comptes spéciaux présentent chacun un document de programmation pluriannuelle des dépenses (DPPD) qui regroupe les programmes qui leurs sont associés."
          },
          {
            terme: "Cadrage macroéconomique",
            definition: "Processus de planification et de préparation du budget qui permet d'allouer les ressources en assurant une discipline budgétaire d'ensemble."
          },
          {
            terme: "Charges de l'Etat",
            definition: "La somme de l'ensemble des dépenses et engagements de l'Etat."
          },
          {
            terme: "Collectif budgétaire ou loi de finances rectificative",
            definition: "Recueil de modifications financières dues à la conjoncture pour compléter et corriger les autorisations budgétaires contenues dans la loi de finances initiale. Il est soumis au vote du Parlement en cours d'année."
          },
          {
            terme: "Crédit budgétaire",
            definition: "Autorisation de dépense limitée en montant et spécialisée quant à son objet."
          },
          {
            terme: "Déficit budgétaire",
            definition: "Solde négatif, se référant à une situation où les recettes de l'État (hors remboursement d'emprunt) sont inférieures à ses dépenses (hors emprunt) au cours d'une année."
          },
          {
            terme: "Dépenses en capital",
            definition: "Dépenses d'investissement"
          },
          {
            terme: "Dépenses courantes",
            definition: "Dépense pour couvrir les besoins courants de l'Administration. Il s'agit des dépenses de personnel, du service de la dette, des achats de biens et services et des transferts courants."
          },
          {
            terme: "Dépenses fiscales",
            definition: "Réduction d'impôt ou modalité permettant de différer le paiement de l'impôt ou de la taxe d'un contribuable."
          },
          {
            terme: "Dépenses d'investissement",
            definition: "Concernent des opérations en capital. Elles comprennent les remboursements d'emprunts, les prêts et avances accordés, les dépenses directes d'investissement (acquisitions mobilières et immobilières, travaux neufs, grosses réparations) et les subventions d'équipements versées."
          },
          {
            terme: "Dépenses publiques",
            definition: "Les achats et/ou commandes effectués par l'Etat central."
          },
          {
            terme: "Dette extérieure",
            definition: "La partie de la dette publique libellée en monnaie étrangère."
          },
          {
            terme: "Dette intérieure",
            definition: "La partie de la dette publique libellée en francs CFA."
          },
          {
            terme: "Dette publique",
            definition: "Engagements financiers pris sous forme d'emprunts par l'Etat."
          },
          {
            terme: "Don",
            definition: "Un don est un transfert volontaire de biens sans contrepartie de valeur pour le donateur."
          },
          {
            terme: "Emprunt",
            definition: "Dette contractée sur le marché national et/ou international pour couvrir les dépenses."
          },
          {
            terme: "Finances publiques",
            definition: "Ces sont les finances des personnes publiques à savoir l'Etat et ses établissements publics, les collectivités territoriales (Communes, Régions et Départements). Elles concernent les opérations financières que sont les opérations de recettes et de dépenses (opérations budgétaires) mais aussi les opérations de trésorerie."
          },
          {
            terme: "Impôts",
            definition: "Prélèvement effectué d'autorité et à titre définitif sur les ressources ou sur les biens des individus ou des collectivités, et payé en argent pour subvenir aux dépenses d'intérêt général de l'État ou des collectivités locales."
          },
          {
            terme: "Loi de finances",
            definition: "Texte juridique voté par le Parlement qui retrace et autorise chaque année le prélèvement des ressources d'un Etat et la réalisation des charges pour l'année suivante."
          },
          {
            terme: "Loi de règlement",
            definition: "Loi de finances permettant au Parlement, après la clôture d'une année budgétaire, d'exercer son contrôle sur l'exécution par le Gouvernement des lois de finances initiale et rectificative."
          },
          {
            terme: "Loi organique",
            definition: "C'est une loi relative à l'organisation et au fonctionnement des pouvoirs publics. Votée par le parlement, elle précise ou complète les dispositions de la Constitution qui a fixé les principes généraux."
          },
          {
            terme: "Prêts",
            definition: "C'est un contrat par lequel une personne remet à une autre, à titre précaire, un objet, du matériel, ou des matériaux, des marchandises, ou une somme d'argent, à charge de restitution au terme qu'elles conviennent."
          },
          {
            terme: "Prévisions",
            definition: "Ensemble des techniques ayant pour but d'évaluer la situation économique à une échéance plus ou moins lointaine."
          },
          {
            terme: "Produit Intérieur Brut (PIB)",
            definition: "Indicateur économique de la richesse produite à l'intérieur d'un pays par l'ensemble des branches d'activités en une année."
          },
          {
            terme: "Programme politique",
            definition: "Un programme politique est une planification des ensembles des actions que le gouvernement s'engage à entreprendre pour les années à venir (le mandat)."
          },
          {
            terme: "Recettes",
            definition: "Montant d'argent perçu par l'Etat à travers les taxes, les redevances, les financements extérieurs."
          },
          {
            terme: "Recettes en capital",
            definition: "Paiements comportant une contrepartie correspondant à une opération en capital telle que la vente de biens de capital fixe, de stock, de terrains ou d'actifs incorporels."
          },
          {
            terme: "Recettes fiscales",
            definition: "Paiements sans contrepartie et non remboursables effectués au profit des administrations publiques. Elles comprennent également les droites et frais perçus par les administrations n'ayant aucune commune mesure avec le coût ou l'ampleur du service fourni au payeur."
          },
          {
            terme: "Recettes non fiscales",
            definition: "Elles comprennent tous les encaissements non remboursables des administrations publiques ayant une contrepartie à l'exception de ceux qui proviennent des ventes de biens en capital, toutes les amendes et pénalités à l'exception de celles relatives aux infractions fiscales, et tous les encaissements courants des administrations publiques représentant des versements volontaires, non remboursables et sans contrepartie."
          },
          {
            terme: "Recettes exceptionnelles",
            definition: "Revenus issus des recettes non traditionnelles de l'Etat."
          },
          {
            terme: "Recettes publiques",
            definition: "L'ensemble des recettes perçues par les administrations publiques et composées essentiellement des impôts et taxes."
          },
          {
            terme: "Ressources de l'Etat",
            definition: "Les recettes et les emprunts."
          },
          {
            terme: "Ressources extérieures",
            definition: "Ressources destinées à des projets d'investissement financés par des bailleurs de fonds non gérées par le Trésor public."
          },
          {
            terme: "Ressources internes",
            definition: "Au sens de la Loi de Finances pour 2019, les ressources internes sont celles gérées par le Trésor public."
          },
          {
            terme: "Solde budgétaire primaire",
            definition: "C'est la différence entre les dépenses et les recettes de l'Etat hors charges d'intérêt de la dette."
          },
          {
            terme: "Solde budgétaire global",
            definition: "Différence entre les recettes totales et dons et, les dépenses totales et prêts nets."
          },
          {
            terme: "Solde budgétaire de base",
            definition: "Recettes totales (hors dons) moins les dépenses courantes (+ les prêts nets) et les dépenses d'investissement public sur ressources internes."
          },
          {
            terme: "Solde budgétaire base engagement",
            definition: "Différence entre recettes totales et dépenses totales."
          },
          {
            terme: "Solde budgétaire base caisse",
            definition: "C'est la somme du solde base engagement et de la variation des arriérées de dépenses."
          },
          {
            terme: "Subvention",
            definition: "Transferts courants sans contrepartie que les administrations publiques versent à des producteurs résidents dans le but d'influencer leurs niveaux de production, leurs prix ou la rémunération des facteurs de production."
          },
          {
            terme: "Taux de change",
            definition: "C'est la valeur d'une monnaie nationale par rapport à celle d'un autre pays."
          },
          {
            terme: "Transfert",
            definition: "Il correspond aux biens et services individuels fournis aux ménages."
          }
        ];
        
        filtrerTermes();
        $scope.loading = false;
      }, 500); // Ajout d'un délai de 500ms pour simuler un chargement
    }


    /**
     * Filtre les termes selon les critères de recherche
     */
    function filtrerTermes() {
      var resultat = $scope.termes;

      // Filtrer par lettre si une lettre est sélectionnée
      if ($scope.lettreActive && $scope.lettreActive !== 'all') {
        resultat = resultat.filter(function(item) {
          return item.terme.charAt(0).toUpperCase() === $scope.lettreActive;
        });
      }

      // Filtrer par texte de recherche
      if ($scope.filtreTerme && $scope.filtreTerme.length > 0) {
        var filtreTermeNormalise = $scope.filtreTerme.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
        
        resultat = resultat.filter(function(item) {
          var termeNormalise = item.terme.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          var definitionNormalise = item.definition.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
          
          return termeNormalise.includes(filtreTermeNormalise) || 
                 definitionNormalise.includes(filtreTermeNormalise);
        });
      }

      $scope.termesFiltres = resultat;
    }

    /**
     * Fonction pour filtrer par lettre
     */
    $scope.filtrerParLettre = function(lettre) {
      $scope.lettreActive = lettre;
      filtrerTermes();
    };
  }
})();
